
import html2canvas from 'html2canvas'
import config from '@/config/index'
import { getMyList, getGroupShare, completeOrder } from '@/api/pintuan'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import Scroll from '@/components/scroller'
export default {
directives: {
TransferDom
},
components: { Tab, TabItem, Scroll, XDialog, Qrcode },
data () {
return {
showDialog: false,
baseUrl: config.baseUrl,
active: 0,
status: '',
list: [],
page: 1,
rows: 20,
notFirstLoad: false,
loadMoreDom: null,
dialogObj: {},
shareObj: {},
qrcodeUrl: '',
downImgUrl: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getMyList()
},
methods: {

shareImg () {
html2canvas(this.$refs.imageWrapper, { scrollY: 0 }).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},
getMyList (type, done) {
getMyList({
status: this.status || '',
accountid: this.accountid,
page: this.page,
rows: this.rows
})
.then(res => {
if (res.status === 'suc') {
if (type === 'refresh') {
this.list = []
this.listDom.scrollTop = 0
this.loadMoreDom.style.display = 'flex'
}
let obj = res.returnValue.list
if (obj.length === 0 && this.page === 1) {
this.list = []
this.loadMoreDom.innerText = '暂无数据'
this.loadMoreDom.style.display = 'flex'
} else {
this.list = this.page === 1 ? obj : [...this.list, ...obj]
if (this.list.length === res.returnValue.total) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
done && done()
}
})
.catch(() => {
this.notFirstLoad = true
done && done()
})
},
onItemClick (index, status) {
if (this.active !== index + 1) {
this.active = index + 1
this.page = 1
this.status = status
this.getMyList()
}
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getMyList('refresh', done)
},

loadMore (done) {
this.page++
this.loadMoreDom.innerText = '加载中...'
this.getMyList('more', done)
},
goDetail (id) {
this.$router.push({
name: 'pintuanOrderDetail',
params: {
id: id
}
})
},

share (obj) {
getGroupShare({
groupid: obj.groupid,
accountid: this.accountid
}).then(res => {
this.shareObj = res.returnValue
this.dialogObj = obj
let link = this.baseUrl + 'wechat/youzheng/pintuan/share/' + this.shareObj.shareccountid + '/' + this.shareObj.id
this.qrcodeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + link + '/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
this.showDialog = true
setTimeout(() => {
this.shareImg()
}, 500)
})
},

confirm (obj, index) {
completeOrder({
id: obj.id,
accountid: this.accountid
}).then(res => {
this.$vux.toast.text('提交成功', 'middle')
this.$set(this.list[index], 'status', 5)
this.$set(this.list[index], 'statusNAME', '订单完成')
})
}
}
}
